import { CommonModule } from '@angular/common';
import { Component, input, inject, effect, signal } from '@angular/core';
import { CountryService } from '@shared/services/country-service/country-service';

@Component({
  selector: 'app-factor-select-country',
  imports: [CommonModule],
  templateUrl: './factor-select-country.html',
  styleUrl: './factor-select-country.scss',
})
export class FactorSelectCountry {
  private countryService = inject(CountryService);
  
  countryIso2 = input.required<string>();
  stateName = input<string>('');
  
  countryName = signal<string | null>(null);

  constructor() {
    // Método que se ejecuta cuando cambia countryIso2
    effect(() => {
      const iso2 = this.countryIso2();
      if (iso2) {
        // Obtener el nombre del país basándose en el código ISO2
        this.countryService.getCountryNameByIso2(iso2).subscribe({
          next: (name) => {
            this.countryName.set(name);
          },
          error: () => {
            this.countryName.set(null);
          }
        });
      } else {
        this.countryName.set(null);
      }
    });
  }

  onFlagError(event: Event): void {
    const img = event.target as HTMLImageElement;
  
    // Se elimina el src para evitar bucles de error
    img.src = '';
  
    // Se agrega una clase que mostrará el placeholder gris
    img.classList.add('flag-placeholder');
  }
  
}